import { useEffect, useState } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { api } from "@/lib/api";
import { Loader, Seo } from "@/components/brand";

export default function CmsPage() {
  const { slug } = useParams();
  const legal = useLocation().pathname.startsWith("/legal");
  const [page, setPage] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => {
    setPage(null);
    setMissing(false);
    api.get(`/cms/${slug}`).then((r) => setPage(r.data)).catch(() => setMissing(true));
    window.scrollTo(0, 0);
  }, [slug]);
  if (missing) return <main className="py-40 text-center"><h1 className="text-4xl font-bold text-white">Page not found</h1><Link to="/" className="mt-6 inline-block text-health">Back home</Link></main>;
  if (!page) return <Loader />;
  return (
    <main data-testid={`cms-page-${slug}`}>
      <Seo title={page.seo_title} description={page.seo_description} />
      <section className="relative overflow-hidden border-b border-white/10 grid-bg">
        <div className="mx-auto max-w-5xl px-5 py-24 lg:px-8">
          <p className="eyebrow">{legal ? "Legal" : "Saflr"}</p>
          <h1 className="mt-4 text-4xl font-bold text-white sm:text-5xl lg:text-6xl fade-up">{page.title}</h1>
          {page.subtitle && <p className="mt-5 max-w-2xl text-base text-slate-400 md:text-lg">{page.subtitle}</p>}
        </div>
      </section>
      <section className="mx-auto max-w-5xl space-y-10 px-5 py-16 lg:px-8">
        {(page.sections || []).map((s, i) => (
          <article key={i} className="rounded-3xl border border-white/10 bg-white/[0.02] p-8">
            <h2 className="text-2xl font-semibold text-white">{s.heading}</h2>
            {legal ? (
              <p className="mt-4 whitespace-pre-line leading-relaxed text-slate-300">{s.body}</p>
            ) : (
              <ul className="mt-6 grid gap-3 sm:grid-cols-2">
                {s.body.split("\n").filter(Boolean).map((b) => <li key={b} className="flex gap-3 rounded-xl border border-white/5 bg-navy-2 p-4 text-sm text-slate-300"><Check className="h-4 w-4 shrink-0 text-health" />{b}</li>)}
              </ul>
            )}
          </article>
        ))}
        {!legal && (
          <div className="flex flex-col items-start justify-between gap-4 rounded-3xl bg-health p-8 text-navy sm:flex-row sm:items-center">
            <div><h3 className="text-2xl font-bold">Describe the job. Let Saflr do the paperwork.</h3><p className="mt-1 text-sm text-navy/70">Start a free trial — no card required.</p></div>
            <Link to="/register" data-testid="cms-cta" className="inline-flex items-center gap-2 rounded-full bg-navy px-6 py-3 font-semibold text-white">Start Creating <ArrowRight className="h-4 w-4" /></Link>
          </div>
        )}
      </section>
    </main>
  );
}
